import { jsx } from '@emotion/react';
import tw from 'twin.macro';

const Header = tw.h2`text-left text-xl font-bold px-8 py-4 border-b`;

export default Header;
